if (navigator.serviceWorker) {
  navigator.serviceWorker.register('/service-worker.js')
    .then(function(reg) {
      console.log('[Page] Service worker registered');
    })
    .catch((error) => {
      console.error("[Page] Error during service worker registration:", error);
    });
}
